import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import * as filters from '@/filters/I18nFilters'

Vue.use(VueI18n)

const i18nIviewMap: { [id: string]: string } = {
	en: 'en-US',
	tw: 'zh-TW',
}

const dateTimeFormats = {
	tw: {
		date: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		},
		short: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: false,
		},
		long: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			weekday: 'short',
			hour: 'numeric',
			minute: 'numeric',
		},
	},
	en: {
		date: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		},
		short: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: false,
		},
		long: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			weekday: 'short',
			hour: 'numeric',
			minute: 'numeric',
		},
	},
}

const numberFormats = {
	en: {
		currency: {
			style: 'decimal',
			currency: 'TWD',
		},
	},
	tw: {
		currency: {
			style: 'decimal',
			currency: 'TWD',
		},
	},
}

function loadLocaleMessages(): LocaleMessages {
	const locales = require.context('./i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i)

	const iviewLocales = require.context('view-design/dist/locale', true, /[A-Za-z0-9-_,\s]+\.js$/i)

	const messages: LocaleMessages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = Object.assign(locales(key), iviewLocales('./' + i18nIviewMap[locale] + '.js'))
		}
	})

	return messages
}

let i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'tw',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'tw',
	messages: loadLocaleMessages(),
	dateTimeFormats,
	numberFormats,
})

//註冊所有i18n專用filter
Object.keys(filters).forEach(filter => Vue.filter(filter, (filters as any)[filter](i18n)))

export default i18n
